import { ChevronRightIcon, JoonUIColor } from "@joonapp/web-shared"
import { FlexBox, Typography } from "@joonapp/web-shared"
import { SPACING } from "@joonapp/web-shared"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { useRewardPageStore } from "./hooks/useRewardPageStore"
import Shine from "../../components/coaching/Shine"
import PageContentWrapper from "../../components/pageContentWrapper/PageContentWrapper"
import PageWrapper from "../../components/pageWrapper/PageWrapper"
import { GRADIENTS } from "../../constants"
import useMobile from "../../hooks/useMobile"
import { localStorageItems } from "../../util/storage"

const WelcomeCustomRewards = () => {
  const [isRewardsPreviewLoaded, setIsRewardsPreviewLoaded] = useState(false)
  const [isChildAppPreviewLoaded, setIsChildAppPreviewLoaded] = useState(false)
  const { setShowWelcome } = useRewardPageStore()
  const isMobile = useMobile()
  const { t } = useTranslation()

  const onAddCustomRewardClick = () => {
    localStorage.removeItem(localStorageItems.needsToSeeWelcomeRewards)
    setShowWelcome(false)
  }

  return (
    <PageWrapper style={{ background: GRADIENTS.gradient100 }}>
      <PageContentWrapper mobileGutter>
        <FlexBox
          direction="column"
          align="center"
          gap={SPACING.space6}
          style={{
            marginTop: SPACING.space9,
            paddingLeft: SPACING.space2,
            paddingRight: SPACING.space2,
          }}
        >
          <Typography variant="h2" textAlign="center">
            {t("WCR_TITLE")}
          </Typography>
          <FlexBox
            direction="column"
            align="center"
            gap={SPACING.space4}
            wrap={false}
            style={{
              width: "min(100%, 500px)",
              borderRadius: SPACING.space2,
              padding: SPACING.space4,
              background: JoonUIColor.background.primaryNeutral,
            }}
          >
            <FlexBox direction="column" wrap={false}>
              <Typography
                variant={isMobile ? "bodyXSmall" : "bodySmallBold"}
                textAlign="center"
              >
                {t("WCR_FOR_PARENTS")}
              </Typography>
              <Typography
                variant={isMobile ? "bodySmallBold" : "bodyBold"}
                textAlign="center"
                style={{ whiteSpace: "pre-line" }}
              >
                {t("WCR_PARENTS_DESC")}
              </Typography>
            </FlexBox>
            <img
              src="/images/previews/rewards_preview.svg"
              alt=""
              onLoad={() => setIsRewardsPreviewLoaded(true)}
              style={{
                width: "max(250px, 80%)",
                opacity: isRewardsPreviewLoaded ? 1 : 0,
                transition: "opacity 0.3s",
              }}
            />
            <FlexBox direction="column" wrap={false}>
              <Typography
                variant={isMobile ? "bodyXSmallBold" : "bodySmallBold"}
                textAlign="center"
              >
                {t("WCR_FOR_CHILDREN")}
              </Typography>
              <Typography
                variant={isMobile ? "bodySmallBold" : "bodyBold"}
                textAlign="center"
                style={{ whiteSpace: "pre-line" }}
              >
                {t("WCR_CHILDREN_DESC")}
              </Typography>
            </FlexBox>
            <img
              src="/images/previews/child_rewards_preview.svg"
              alt=""
              onLoad={() => setIsChildAppPreviewLoaded(true)}
              style={{
                width: "max(250px, 92%)",
                opacity: isChildAppPreviewLoaded ? 1 : 0,
                transition: "opacity 0.3s",
              }}
            />
            <button
              style={{
                position: "sticky",
                bottom: isMobile ? "80px" : "12px",
                width: "min(96%, 400px)",
                marginTop: SPACING.space4,
              }}
              onClick={onAddCustomRewardClick}
            >
              <FlexBox
                direction="row"
                align="center"
                justify="space-between"
                wrap={false}
                style={{
                  position: "relative",
                  background: JoonUIColor.background.accent,
                  borderRadius: SPACING.space2,
                  padding: `${SPACING.space2} ${SPACING.space1} ${SPACING.space2} ${SPACING.space3}`,
                  boxShadow: "4px 4px 6px rgba(0, 0, 0, 0.1)",
                  overflow: "hidden",
                }}
              >
                <Typography
                  variant={isMobile ? "bodySmallBold" : "bodyBold"}
                  color={JoonUIColor.text.inverted}
                  style={{ lineHeight: "1.4", whiteSpace: "nowrap" }}
                >
                  {t("WCR_ADD_START")}
                </Typography>

                <div style={{ minWidth: "30px" }}>
                  <ChevronRightIcon
                    color={JoonUIColor.icon.inverted}
                    size={24}
                  />
                </div>
                <Shine />
              </FlexBox>
            </button>
          </FlexBox>
        </FlexBox>
      </PageContentWrapper>
    </PageWrapper>
  )
}

export default WelcomeCustomRewards
